module.exports = __webpack_public_path__ + "img/TwoAxleTractorFourAxleSemitrailer.67a031fc.svg";